import { getPriceInputError } from "./priceInput";

// 全局维护规则（统一管理，便于修改）
export const floatRules = [
  {
    pattern: /^(0|[1-9]\d*)(\.\d{1,4})?$/,
    message: "请填写大于或等于0的值，最多保留4位小数",
    trigger: "onBlur",
  },
];
export const numberRules = [
  {
    pattern: /^[1-9]\d*$/,
    message: "请填写整数",
    trigger: "onBlur",
  },
];
export const stringRules = [
  {
    pattern: /^[a-zA-Z\u4e00-\u9fa5]+$/,
    message: "请输入英文或者中文",
    trigger: "onBlur",
  },
];
export const needRules = [
  {
    required: true,
    message: "请填写",
    trigger: "onBlur",
  },
];

// 空值交给字段已有必填规则；价格精度与通用小数（比例、重量）分开维护。
export function createPriceRules({
  formType = "vant",
  translate = (message) => message,
} = {}) {
  if (formType === "element") {
    return [
      {
        trigger: "blur",
        validator(rule, value, callback) {
          const error = getPriceInputError(value, { optional: true });
          callback(error ? new Error(translate(error)) : undefined);
        },
      },
    ];
  }
  return [
    {
      trigger: "onBlur",
      validator: (value) => !getPriceInputError(value, { optional: true }),
      message: (value) =>
        translate(getPriceInputError(value, { optional: true })),
    },
  ];
}
